import { render } from "./ProjectCard.vue?vue&type=template&id=f2e23388"
import script from "./ProjectCard.vue?vue&type=script&lang=js"
export * from "./ProjectCard.vue?vue&type=script&lang=js"
script.render = render

export default script